import React from 'react';

const ModalBase = ({ show, onClose, children }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-lg">
        {children}
      </div>
    </div>
  );
};

export default ModalBase;
